import React from 'react';
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {LivePenaltiesModuleFooterButtons} from "./live-penalties-module.footer-buttons";
import styles from "../styles/live-penalties-module.module.scss";
import classNames from "classnames";
import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {LivePenaltiesModuleHeader} from "./live-penalties-module.header";
import {LivePenaltiesModuleContent} from "./live-penalties-module.content";
import {LivePenaltiesModuleController} from "../live-penalties-module.controller";

export class LivePenaltiesModuleComponentProps extends BaseModuleProps {}

export const LivePenaltiesModuleModuleComponent = ({
                                                     controller,
                                                     source,
                                                     onClose,
                                                     competitionId
                                                   }: LivePenaltiesModuleComponentProps) => {
  const {device: {isSmallView}} = controller;

  const headerProps = {
    controller,
    source
  }

  const footerButtonsProps = {
    controller,
    onClose,
    competitionId
  }

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView})}>
      <LivePenaltiesModuleHeader {...headerProps}/>
      <LivePenaltiesModuleContent controller={controller}/>
      <LivePenaltiesModuleFooterButtons {...footerButtonsProps}/>
    </div>
  )
};

const settings: ComposeSettings = {
  component: LivePenaltiesModuleModuleComponent,
  propsType: LivePenaltiesModuleComponentProps,
  controllerType: LivePenaltiesModuleController,

  observe: true,
  createModule: true,
}

export const LivePenaltiesModule = Compose(settings);
